import { HomeViewType } from '@/core/presenter/viewModel/viewTypes';
import * as ViewModel from '@/core/presenter/viewModel';
import { SOL_SYMBOL_ICON_PATH } from '@/consts/imgPath';

interface IProps {
  trxAsset?: ViewModel.IAsset;
  trxBalance: string;
  trxKrw: string;
  trxPrice: number;
  onClickViewType: (viewType: HomeViewType) => void;
}

const TrxProperty = ({ trxAsset, trxBalance, trxKrw, trxPrice, onClickViewType }: IProps) => {
  // 소수점 6자리까지 표시하고 나머지 버림 처리, 뒤의 불필요한 0 제거
  const formattedTrxBalance = trxBalance
    ? (() => {
        const value = Math.floor(Number(trxBalance) * 1000000) / 1000000;
        const fixed = value.toFixed(6);
        // 뒤의 불필요한 0 제거
        return fixed.replace(/\.?0+$/, '') || '0';
      })()
    : '0';

  return (
    <div className="coin-item cursor-pointer" id="solCoin" onClick={() => onClickViewType(HomeViewType.SOL)}>
      <img src={SOL_SYMBOL_ICON_PATH} alt="솔라나" className="coin-icon" />
      <div className="coin-info">
        <p className="coin-name text-base font-semibold">{trxAsset?.name}</p>
        <p className="coin-symbol text-sm font-normal">
          1 {trxAsset?.symbol} = {trxPrice.toLocaleString()}원
        </p>
      </div>
      <div className="coin-amount">
        <p className="coin-balance text-base font-semibold">
          {formattedTrxBalance} {trxAsset?.symbol}
        </p>
        <p className="coin-krw text-sm font-bold">{trxKrw} 원</p>
      </div>
    </div>
  );
};

export default TrxProperty;

{
  /* <li>
      <a className="property" href="#" onClick={() => onClickViewType(HomeViewType.SOL)}>
        <div className="left">
          <div className="symbol-area">
            <div className="img icon_margin_top">
              <img src={SOL_SYMBOL_ICON_PATH} alt="trx" / >
            </div>
            <div className="top asset_double_s line_height">
              <p className="fw-l body-xl asset_double_p asest_margin_right_trx">
                {trxAsset?.name} <span className="asset_symbol">{trxAsset?.symbol}</span>
              </p>
              <span className="body-l asset_price asest_margin_right asset_margin_right">
                1 SOL = {trxPrice.toLocaleString()}원
              </span>
            </div>
          </div>
        </div>
        <div className="right">
          <div className="top">
            <p className="coin body-xl">{formattedTrxBalance} SOL</p>
            <span className="krw fw-b body-l">{trxKrw} 원</span>
          </div>
        </div>
      </a>
    </li> */
}
